import {
  PECriminalHistoriesCardActions, PECriminalHistoriesCardGetters, PECriminalHistoriesCardMutations,
} from './pe-criminal-histories-card'
import {
  PEDetentionHistoriesCardActions, PEDetentionHistoriesCardGetters, PEDetentionHistoriesCardMutations,
} from './pe-detention-histories-card'
import {
  PEEducationHistoriesCardActions, PEEducationHistoriesCardGetters, PEEducationHistoriesCardMutations,
} from './pe-educational-histories-card'
import {
  PEImmigrationStatusHistoriesCardActions,
  PEImmigrationStatusHistoriesCardGetters,
  PEImmigrationStatusHistoriesCardMutations,
} from './pe-immigration-status-histories-card'
import {
  PEJobHistoriesCardActions, PEJobHistoriesCardGetters, PEJobHistoriesCardMutations,
} from './pe-job-histories-card'
import {
  PEResidenceHistoriesCardActions, PEResidenceHistoriesCardGetters, PEResidenceHistoriesCardMutations,
} from './pe-residence-histories-card'
import {
  PETravelHistoriesCardActions, PETravelHistoriesCardGetters, PETravelHistoriesCardMutations,
} from './pe-travel-histories-card'

export const HistorySectionActions = {
  ...PECriminalHistoriesCardActions,
  ...PEDetentionHistoriesCardActions,
  ...PEEducationHistoriesCardActions,
  ...PEImmigrationStatusHistoriesCardActions,
  ...PEJobHistoriesCardActions,
  ...PEResidenceHistoriesCardActions,
  ...PETravelHistoriesCardActions,
}

export const HistorySectionGetters = {
  ...PECriminalHistoriesCardGetters,
  ...PEDetentionHistoriesCardGetters,
  ...PEEducationHistoriesCardGetters,
  ...PEImmigrationStatusHistoriesCardGetters,
  ...PEJobHistoriesCardGetters,
  ...PEResidenceHistoriesCardGetters,
  ...PETravelHistoriesCardGetters,
}

export const HistorySectionMutations = {
  ...PECriminalHistoriesCardMutations,
  ...PEDetentionHistoriesCardMutations,
  ...PEEducationHistoriesCardMutations,
  ...PEImmigrationStatusHistoriesCardMutations,
  ...PEJobHistoriesCardMutations,
  ...PEResidenceHistoriesCardMutations,
  ...PETravelHistoriesCardMutations,
}
